import React from 'react';

const MobileIDIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 48 48" {...props}>
    <path d="M21.7379 5.07382C20.8001 4.13585 19.5282 3.60889 18.2019 3.60889C16.8756 3.60889 15.6036 4.13585 14.6659 5.07382L4.79987 14.9458C2.84796 16.8983 2.84796 20.0633 4.79987 22.0158L23.7279 40.9438C25.6804 42.8957 28.8454 42.8957 30.7979 40.9438L40.6679 31.0738C41.6058 30.1361 42.1328 28.8641 42.1328 27.5378C42.1328 26.2115 41.6058 24.9395 40.6679 24.0018L21.7379 5.07382ZM20.2619 8.89582L34.2619 22.8958C35.0426 23.6768 35.0426 24.9428 34.2619 25.7238L25.4439 34.5438C24.6629 35.3246 23.3969 35.3246 22.6159 34.5438L8.61587 20.5438C8.24032 20.1687 8.0293 19.6596 8.0293 19.1288C8.0293 18.598 8.24032 18.089 8.61587 17.7138L17.4339 8.89582C18.2149 8.11505 19.4809 8.11505 20.2619 8.89582Z" />
  </svg>
);

export default MobileIDIcon;
